import { useEffect } from "react";

export function ImageLightbox({ imageToDisplay, machineTitle, onClose }) {
  useEffect(() => {
    if (!imageToDisplay) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [imageToDisplay, onClose]);

  if (!imageToDisplay) return null;

  return (
    <div
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label={`Fullbild av ${machineTitle}`}
      onClick={onClose}
      onKeyUp={(e) => {
        if (e.key === "Escape") onClose();
      }}
    >
      <button
        type="button"
        className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-1 z-[51] hover:bg-black/80 transition-colors"
        onClick={onClose}
        aria-label="Stäng"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <title>Stäng</title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      {/* biome-ignore lint/a11y/noStaticElementInteractions: stop click-through to close overlay */}
      <div
        className="relative inline-flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
        onKeyUp={(e) => e.stopPropagation()}
      >
        <img
          src={imageToDisplay}
          alt={machineTitle}
          className="max-w-[95vw] max-h-[90vh] object-contain block"
        />
      </div>
    </div>
  );
}
